import Http from './http'
// import {The_Ability} from '../store/index'

export default {
	index_new(){
    return Http.get(`/notifications?limit=${20}&filter=unopened`)
  },
  index(){
    return Http.get(`/notifications?limit=${20}`)
  },
  index_opened(){
    return Http.get(`/notifications?limit=${20}&filter=opened`)
  },

  readNotification(id){
    return Http.put(`/notifications/${id}/open`)
  },

  readManyNotifications(ids){
    return Http.post(`/notifications/open_all`)
  }
}